import * as R from 'ramda';
import { ActionType } from '../../core/redux/actionType';
import { makeApiAction, makeRsaaTypes, ApiReducer, makeApiReducer } from '../../core/api/rsaa';
import { Endpoints } from '../../core/api/endpoints';
import { getLoading, addLoading, addError, noLoadingNoError } from '../../core/api/module';
import { DashboardDefaults } from '../models';


const KEY_ACTION = ActionType.GetDashboardDefaultsRequest;
const ACTIONS    = [
  ActionType.GetDashboardDefaultsRequest,
  ActionType.GetDashboardDefaultsResponse,
  ActionType.GetDashboardDefaultsError,
];


type Payload = DashboardDefaults;


type Meta = {
  userClientId: number;
};


/**
 * Dispatch this action to retrieve the default client and assessment ids for a user's client
 *
 * @param userClientId - the client id for the currently logged in user
 */
export const getDashboardDefaultsAction = (
  userClientId: number,
) => makeApiAction<Payload, Meta>(
  {
    method:   'POST',
    endpoint: Endpoints.GetDashboardDefaults,
    headers:  { 'content-type': 'application/json' },
    body:     JSON.stringify({
      userClientId,
    }),
    types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { userClientId }),
    bailout:  state => !!getLoading(state, KEY_ACTION, `${userClientId}`),
  },
);

const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  const { userClientId } = action.meta;

  const metaTag       = `${userClientId}`;

  if (isLoading) {
    return addLoading(state, KEY_ACTION, metaTag);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg, metaTag);
  }

  const successState = noLoadingNoError(state, KEY_ACTION, metaTag);

  if (!payload) {
    return successState;
  }

  return R.assocPath(
    ['dashboardDefaults'],
    payload,
    successState,
  );
};

export const getDashboardDefaultsReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
